import React, { useState, useEffect } from "react";
import { ChevronDown, Play, Square, User } from "lucide-react";

export function fmtClock(secs) {
  const s = Math.max(0, Math.floor(secs || 0));
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), ss = s % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
}

export function StatusMenu({ value, options, onChange, testid }) {
  const [open, setOpen] = useState(false);
  const cur = options.find((o) => o.id === value) || options[0];
  return (
    <div className="relative inline-block" onClick={(e) => e.stopPropagation()}>
      <button data-testid={testid} onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-1.5 px-2 py-1 rounded-md text-[11px] font-mono-label uppercase tracking-wider border hover:brightness-125"
        style={{ color: cur.color, borderColor: cur.color + "40", background: cur.color + "12" }}>
        <span className="w-1.5 h-1.5 rounded-full" style={{ background: cur.color }} />{cur.label}<ChevronDown size={11} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute left-0 top-full mt-1 z-50 bg-card border border-white/10 rounded-lg py-1 w-44 shadow-xl">
            {options.map((o) => (
              <button key={o.id} data-testid={`${testid}-${o.id}`} onClick={() => { onChange(o.id); setOpen(false); }}
                className="w-full flex items-center gap-2 px-3 py-1.5 text-xs hover:bg-white/[0.06] text-left">
                <span className="w-2 h-2 rounded-full" style={{ background: o.color }} />{o.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export function AssignMenu({ value, members, onChange, testid }) {
  const [open, setOpen] = useState(false);
  const cur = members.find((m) => m.user_id === value);
  return (
    <div className="relative inline-block" onClick={(e) => e.stopPropagation()}>
      <button data-testid={testid} onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-1.5 px-2 py-1 rounded-md text-xs border border-white/10 hover:border-white/30 text-zinc-300 max-w-[140px]">
        <User size={12} /><span className="truncate">{cur ? cur.name : "—"}</span><ChevronDown size={11} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute left-0 top-full mt-1 z-50 bg-card border border-white/10 rounded-lg py-1 w-48 shadow-xl max-h-60 overflow-y-auto">
            <button onClick={() => { onChange(""); setOpen(false); }} className="w-full px-3 py-1.5 text-xs hover:bg-white/[0.06] text-left text-zinc-400">— Personne —</button>
            {members.map((m) => (
              <button key={m.user_id} data-testid={`${testid}-${m.user_id}`} onClick={() => { onChange(m.user_id); setOpen(false); }}
                className="w-full px-3 py-1.5 text-xs hover:bg-white/[0.06] text-left">{m.name}</button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export function TimerButton({ task, onToggle, testid }) {
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!task.timer_running) return;
    const i = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(i);
  }, [task.timer_running]);
  let secs = task.time_spent_seconds || 0;
  if (task.timer_running && task.timer_started_at) {
    secs += Math.floor((Date.now() - new Date(task.timer_started_at).getTime()) / 1000);
  }
  return (
    <button data-testid={testid} onClick={(e) => { e.stopPropagation(); onToggle(task); }}
      className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-md text-[12px] font-cabinet font-semibold tabular-nums border ${task.timer_running ? "bg-signal/15 border-signal/40 text-signal animate-pulse" : "border-white/10 text-zinc-300 hover:border-white/30"}`}>
      {task.timer_running ? <Square size={11} /> : <Play size={11} />} {fmtClock(secs)}
    </button>
  );
}
